export enum ButtonSize {
  SMALL = 'SMALL',
}

export enum ButtonFlavor {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  SECONDARY = 'SECONDARY',
  PRIMARY = 'PRIMARY'
}

export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit'
}
